export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 72;

export type PasswordValidationResult =
  | { valid: true }
  | { valid: false; error: string };

export function validatePassword(
  password: string,
  email: string,
): PasswordValidationResult {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return {
      valid: false,
      error: 'Password needs to be at least 15 characters long.',
    };
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return {
      valid: false,
      error: 'Password needs to be at most 72 characters long.',
    };
  }
  const [localPart, domain] = email.split('@');
  if (localPart && password.includes(localPart)) {
    return { valid: false, error: 'Password cannot contain your username.' };
  }
  if (domain && password.includes(domain)) {
    return {
      valid: false,
      error: 'Password cannot contain your email domain.',
    };
  }
  if (password.toLowerCase().includes('seaber')) {
    return { valid: false, error: 'Password cannot contain "seaber".' };
  }
  return { valid: true };
}

export function parsePasswordError(errorMessage: string): string | null {
  if (errorMessage.includes('at least 15 characters')) {
    return 'Password needs to be at least 15 characters long.';
  }
  if (errorMessage.includes('at most 72 characters')) {
    return 'Password needs to be at most 72 characters long.';
  }
  if (errorMessage.includes('user name')) {
    return 'Password cannot contain your username.';
  }
  if (errorMessage.includes('domain name')) {
    return 'Password cannot contain your email domain.';
  }
  if (errorMessage.includes('seaber')) {
    return 'Password cannot contain "seaber".';
  }
  return null;
}
